import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import cosignInstance from '../../i18n/i18nConfig'
import { useContextCosign } from '../useContextCosign'

const styles = stylex.create({
  termsContainer: {
    color: '#7A7A7A',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '12px',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '24px',
  },
  termsLinkContainer: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  link: {
    textDecoration: 'none',
    color: '#178CFA',
    fontSize: '12px',
    lineHeight: '130%',
  },
})

export function Terms() {
  const { privacypoliciesLink, intellectualLink } = useContextCosign()
  const { t } = useTranslation('translation', { i18n: cosignInstance })
  return (
    <div {...stylex.props(styles.termsContainer)}>
      <Text align="center" variant="caption">{t('login.terms.content')}</Text>
      <div {...stylex.props(styles.termsLinkContainer)}>
        <a href={privacypoliciesLink} {...stylex.props(styles.link)}>{t('login.terms.termsServiceAndPrivacyPolicy')}</a>
        <Text variant="caption">
          &nbsp;
          {t('login.terms.and')}
          &nbsp;
        </Text>
        <a href={intellectualLink} {...stylex.props(styles.link)}>{t('login.terms.intellectualPropertyStatement')}</a>
      </div>
    </div>
  )
}
